import script from "./SubtitlesDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./SubtitlesDrawer.vue?vue&type=script&setup=true&lang=js"

import "./SubtitlesDrawer.vue?vue&type=style&index=0&id=10152611&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/duanju-overseas_admin_vue_live/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10152611"]])

export default __exports__